import { Button, Text, TextField } from '@cinesend/ui-kit'
import { useState } from 'react'
import useAuth from '../../hooks/use_auth'
import SettingsCard from '../../components/settings_card'

export default function Security({ user, updateUser }) {
  const { logOut } = useAuth()
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  return (
    <>
      <SettingsCard title='Password'>
        <TextField
          disabled={user.is_oidc}
          label='Current password'
          type='password'
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
        />
        <TextField
          disabled={user.is_oidc}
          label='New password'
          type='password'
          description='Must contain at least 8 characters, one uppercase character, one number, and one special character.'
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <TextField
          disabled={user.is_oidc}
          label='Confirm new password'
          type='password'
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        <div className='flex justify-end'>
          <Button
            disabled={newPassword !== confirmPassword || !newPassword || !currentPassword || user?.is_oidc}
            onClick={() =>
              updateUser({
                current_password: currentPassword,
                password: newPassword,
                password_confirmation: confirmPassword,
              })
            }
          >
            Change password
          </Button>
        </div>
      </SettingsCard>
      <SettingsCard title='Log out'>
        <div className='flex items-center gap-6'>
          <div className='min-w-0 flex-1'>
            <Text variant='sm-medium'>Log out of this device</Text>
          </div>
          <Button type='button' variant='secondary' onClick={() => logOut.mutate()} disabled={logOut.isLoading}>
            Log out
          </Button>
        </div>
      </SettingsCard>
    </>
  )
}
